
import Vue from "vue";
import { mapGetters } from "vuex";
import UserProfileUpdateCard from "@/components/parts/UserProfileUpdateCard.vue";
import GuestProfileUpdateCard from "@/components/parts/GuestProfileUpdateCard.vue";
export default Vue.extend({
  components: {
    UserProfileUpdateCard,
    GuestProfileUpdateCard,
  },
  computed: {
    ...mapGetters({
      isCast: "auth/isCast",
      isGuest: "auth/isGuest",
    }),
  },
});
